import { Typography } from "@mui/material";
import { ControllerFieldState } from "react-hook-form";
import InfoIcon from '@mui/icons-material/Info';
import { ReactNode } from "react";

interface CodeFieldCustomErrorBoxProps {
    fieldState: ControllerFieldState; // Error message to display
    helperText?: ReactNode;
}

const CodeFieldCustomErrorBoxComponent = ({ fieldState, helperText }: CodeFieldCustomErrorBoxProps) => {
    const message = fieldState.error?.message || helperText;

    if (!message) {
        return (
            <>
                {/* No error, so return an empty fragment */}
            </>
        )
    };

    return (
        <Typography variant="body2" color={fieldState.error ? "error" : "text.secondary"} sx={{ display: "flex", alignItems: "center", mt: 1, marginLeft: "10px" }}>
            <span style={{ display: "flex" }}>
                <span style={{ marginRight: 4 }}>
                    <InfoIcon fontSize="small" color={fieldState.error ? "error" : "info"} />
                </span>
                {message}
            </span>
        </Typography>
    );
};

export default CodeFieldCustomErrorBoxComponent;
